// vuetify.js
import 'vuetify/styles'; // Global CSS
// Bundled so icons (toolbar buttons, checkboxes) work offline from the service worker cache
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';

const vuetify = createVuetify({
  // Add your Vuetify theme, components, or configuration here
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#1867C0', // Focus color
          important: '#bcf1ae', // Background color
          required: '#f3b7ac9a',
          default: '#ffffff'
        },
      },
    },
  },
  defaults: {
    VTextField: {
      variant: 'outlined',
    },
    VSelect: {
      variant: 'outlined',
    },
  },
});

export default vuetify;